import ShelterlyPDF from '../utils/pdf';
import { createQrCode } from '../utils/qrCode';

async function buildAccessQRPage (data) {
	const pdf = new ShelterlyPDF({}, {
	pageTitle: `Incident: ${data.instance.incident_name}`,
	pageSubtitle: `Organization:  ${data.instance.org_name}\nExpiration Date: ${data.instance.link_expires_at}`,
	drawHeaderOnEveryPage: true
	});
	let accessQR = createQrCode(data.accessUrl, {size: 400});
	await pdf.drawImage({src: accessQR, padding: 60, maxHeight: 400, maxWidth: 400});
	pdf.fileName = `IncidentAccess-` + data.instance.org_name + '-' + data.instance.incident_name + '.pdf'
	return pdf.saveFile();
}

export {buildAccessQRPage};